import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation("langSwitch");
  const [hover, setHover] = useState(false);
  const current = (i18n.language || "de").startsWith("en") ? "en" : "de";
  const other = current === "en" ? "de" : "en";
  const label = other === "en" ? t("en") : t("de");

  return (
    <button
      type="button"
      onClick={() => i18n.changeLanguage(other)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      aria-label={t("aria")}
      className="inline-flex items-center justify-center text-[11px] font-mono uppercase tracking-[0.1em] transition-colors"
      style={{
        minWidth: 40,
        height: 26,
        padding: "0 10px",
        borderRadius: 999,
        backgroundColor: hover ? "#FF3C00" : "rgba(255,255,255,0.06)",
        color: hover ? "#fff" : "#d4d4d8",
        border: `1px solid ${hover ? "#FF3C00" : "rgba(255,255,255,0.1)"}`,
      }}
    >
      {label}
    </button>
  );
}
